import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @atlaskit
import { ButtonGroup } from '@atlaskit/button';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';
import DocumentsIcon from '@atlaskit/icon/glyph/documents';
import DynamicTable from '@atlaskit/dynamic-table';
import EditFilledIcon from '@atlaskit/icon/glyph/edit-filled';
import ShareIcon from '@atlaskit/icon/glyph/share';

// @source
import { crypto } from '../../../../../utils';
import { Messages } from '../../../../components';
import { Report as API } from '../../../../../server';
import OperationButton from './OperationButton';

const initialState = {
  message: false,
};

const initialStatic = {
  page: 1,
  sortKey: 'update-date',
  sortOrder: 'DESC',
};

const renderDynamicTableHead = {
  cells: [{
    key: 'Name',
    content: 'Name',
    isSortable: true,
    width: 500,
  }, {
    key: 'update-date',
    content: 'Update Date',
    isSortable: true,
    width: 400,
  }, {
    key: 'Transactions',
    content: '',
    width: 153,
  }],
};

class TableView extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.static = initialStatic;
    this.unmount = false;
  }

  componentDidMount() {
    if (!this.props.reports.override) {
      API.fetch({
        dispatch: this.props.dispatch,
        error: (messages) => {
          this.setStateUnmount({
            message: (
              <Messages
                items={messages}
                onClose={() => this.setState({ message: false })}
              />
            ),
          });
        },
      });
    }
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  setStatic(state) {
    this.static = { ...this.static, ...state };
  }

  renderDynamicTableRows() {
    return this.props.reports.data.map(report => ({
      key: report.Name,
      cells: [
        { content: report.Name },
        { content: report.UpdateDate },
        {
          content: (
            <div className="spotlight">
              <ButtonGroup>
                {OperationButton({
                  href: `edit/${crypto.encode(report.Name)}`,
                  Icon: EditFilledIcon,
                  tooltip: 'Edit report',
                })}
                {OperationButton({
                  href: `permissions?uuid=${crypto.encode(report.Name)}`,
                  Icon: ShareIcon,
                  tooltip: 'Permission report',
                })}
                {OperationButton({
                  href: `duplicate?uuid=${crypto.encode(report.Name)}`,
                  Icon: DocumentsIcon,
                  tooltip: 'Duplicate report',
                })}
                {OperationButton({
                  href: `delete?uuid=${crypto.encode(report.Name)}`,
                  Icon: CrossCircleIcon,
                  tooltip: 'Delete report',
                })}
              </ButtonGroup>
            </div>
          ),
        },
      ],
    }));
  }

  render() {
    return (
      <div className="dynamic-table" style={{ marginTop: 25 }}>
        <DynamicTable
          defaultSortKey={this.static.sortKey}
          defaultSortOrder={this.static.sortOrder}
          emptyView={this.state.message ? false : <i>No reports have been created yet.</i>}
          head={renderDynamicTableHead}
          isFixedSize
          isLoading={!this.props.reports.override}
          loadingSpinnerSize="large"
          onSetPage={page => this.setStatic({ page })}
          page={this.static.page}
          rows={this.renderDynamicTableRows()}
          rowsPerPage={11}
          onSort={(value) => {
            this.setStatic({
              sortKey: value.key,
              sortOrder: value.sortOrder,
            });
          }}
        />
        {this.state.message}
      </div>
    );
  }
}

TableView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  reports: PropTypes.shape().isRequired,
};

const mapStateToProps = state => ({
  reports: state.Report,
});

export default connect(mapStateToProps)(TableView);
